import { Motion } from 'vue-motion';
import ResizeObserver from 'resize-observer-polyfill';

var TransformContainer = {
  name: 'TransformContainer',
  props: {
    transformValue: {
      default: '0px',
      type: String
    },
    padding: {
      default: '0px',
      type: String
    },
    orientation: {
      default: 'vertical',
      type: String
    }
  },
  render: function render(h) {
    var this$1 = this;
    var obj;

    var pattern = /(\d*\.?\d*)(%|px)/;
    var ref = this.transformValue.match(pattern);
    var transform = ref[1];
    var unit = ref[2];
    var getCSSTransform = function (value, unit) {
      return this$1.orientation === 'horizontal' ? ("translate3d(-" + value + unit + ", 0px, 0px)") : ("translate3d(0px, -" + value + unit + ", 0px)");
    };
    return h(Motion, {
      props: {
        value: Number(transform),
        tag: 'div'
      },
      class: 'viewport',
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden'
      },
      on: {
        // 'motion-end': this._stopTransition,
      },
      scopedSlots: {
        default: function (ref) {
          var value = ref.value;

          this$1.$emit('tick', value);
          return h('div', {
            class: 'transformcontainer',
            style: ( obj = {
              transform: getCSSTransform(value, unit),
              display: 'flex',
              flexDirection: this$1.orientation === 'horizontal' ? 'row' : 'column',
              position: 'absolute',
              width: '100%',
              height: '100%'
            }, obj[this$1.orientation === 'horizontal' ? 'left' : 'top'] = this$1.padding, obj)
          }, this$1.$slots.default);
        }
      }
    });
  }
};

var VirtualViewport = {
  name: 'VirtualViewport',
  functional: true,
  props: {
    index: {
      required: true,
      type: Number
    },
    perPage: {
      required: true,
      type: Number
    },
    orientation: {
      required: true,
      type: String
    },
    offset: {
      type: Number,
      default: 1
    }
  },
  render: function render(h, ctx) {
    var props = ctx.props;
    var children = ctx.children;

    var makeIntervals = function (perPage, offset) {
      var start = 0;
      var end = 0 + perPage;
      return [[start - offset], [start, end], [end, end + offset]];
    };

    var length = children.length;
    var index = props.index;
    var perPage = props.perPage;
    var loop = props.loop;
    var offset = props.offset;
    var realIndex = index < 0 ? (length + index) % length : index % length;
    var intervals = makeIntervals(perPage, offset);

    var loopedChildren = realIndex !== 0 ? children.slice(realIndex, length).concat( (loop ? children.slice(0, realIndex) : [])) : children;

    var currentSlides = loopedChildren.slice.apply(loopedChildren, intervals[1]);
    var afterSlides = loopedChildren.slice.apply(loopedChildren, intervals[2]);

    var slides = [currentSlides, afterSlides];
    return slides;
  }
};

var RenderedSize = {
  name: 'RenderedSize',
  created: function created() {
    var this$1 = this;

    this.$nextTick(function () {
      this$1._computeSize();
      var ro = new ResizeObserver(function (entries, observer) {
        this$1._computeSize();
      });
      ro.observe(this$1.$el);
    });
  },
  methods: {
    _computeSize: function _computeSize() {
      var el = this.$el;
      if (!el) { return; }
      this.$emit('changed', {
        width: el.scrollWidth,
        height: el.scrollHeight
      });
    }
  },
  render: function render(h) {
    // clone the element received via the default slot:
    if (!this.$slots.default) { return; }
    var vNode = this.$slots.default[0];
    var children = vNode.children || vNode.text;
    var slot = h(vNode.tag, vNode.data, children);
    return h('span', {
      style: {
        position: 'absolute',
        visibility: 'hidden',
        left: '-10000px',
        top: '-10000px'
      }
    }, [slot]);
  }
};

function cloneVNodes(vnodes, createElement) {
  function cloneVNode(vnode) {
    var clonedChildren = vnode.children && vnode.children.map(function (vnode) { return cloneVNode(vnode); });
    var cloned = createElement(vnode.tag, vnode.data, clonedChildren);
    cloned.text = vnode.text;
    cloned.isComment = vnode.isComment;
    cloned.componentOptions = vnode.componentOptions;
    cloned.elm = vnode.elm;
    cloned.context = vnode.context;
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    return cloned;
  }
  var clonedVNodes = vnodes.map(function (vnode) { return cloneVNode(vnode); });
  return clonedVNodes;
}

var Slider = {
  name: 'Slider',
  props: {
    perPage: {
      default: 3,
      type: Number
    },
    current: {
      default: 0,
      type: Number
    },
    viewportClass: {
      default: '',
      type: String
    },
    orientation: {
      default: 'vertical',
      type: String
    },
    offset: {
      default: 1,
      type: Number
    },
    loop: {
      default: true,
      type: Boolean
    },
    clone: {
      default: true,
      type: Boolean
    },
    navigationIncrement: {
      default: 1,
      type: Number
    },
    autoSize: {
      default: false,
      type: Boolean
    }
  },
  data: function () { return ({
    index: 0,
    isTransitioning: false,
    effectiveTransform: 0,
    elementSize: 0
  }); },
  computed: {
    canNext: function canNext() {
      if (this.loop) { return true; }
      var length = this.$slots.default.length;
      return this.index + this.navigationIncrement < length;
    },
    canPrev: function canPrev() {
      if (this.loop) { return true; }
      return this.index - this.navigationIncrement >= 0;
    },
    transform: function transform() {
      if (this.autoSize) {
        return (((this.index + this.offset) * this.elementSizeValue) + "px");
      } else {
        return (((this.index + this.offset) * this.percentage) + "%");
      }
    },
    padding: function padding() {
      if (this.autoSize) {
        return ((this.effectiveIndex * this.elementSizeValue + this.offset * this.elementSizeValue) + "px");
      } else {
        return ((this.effectiveIndex * this.percentage + this.offset * this.percentage) + "%");
      }
    },
    effectiveIndex: function effectiveIndex() {
      if (this.autoSize) {
        return Math.floor(-this.effectiveTransform / this.elementSizeValue) - this.offset;
      } else {
        return Math.floor(this.effectiveTransform / this.percentage) - this.offset;
      }
    },
    elementSizeValue: function elementSizeValue() {
      return (this.orientation === 'horizontal' ? this.elementSize.width : this.elementSize.height) || 1;
    },
    percentage: function percentage() {
      return Math.round(1 / this.perPage * 10000) / 100;
    },
    viewportSize: function viewportSize() {
      return this.orientation === 'horizontal' ? { width: this.elementSize.width * this.perPage, height: this.elementSize.height } : { width: this.elementSize.width, height: this.elementSize.height * this.perPage };
    }
  },
  watch: {
    current: {
      immediate: true,
      handler: function handler(val) {
        this.index = val;
      }
    },
    orientation: function orientation(val) {
      this.effectiveTransform = 0;
    },
    loop: function loop(val) {
      this.index = this.current;
    }
  },
  methods: {
    next: function next() {
      this.index = this.canNext ? this.index + this.navigationIncrement : this.index;
    },
    prev: function prev() {
      this.index = this.canPrev > 0 ? this.index - this.navigationIncrement : this.index;
    }
  },
  render: function render(h) {
    var this$1 = this;
    var obj;

    var slotWithClone = (function () {
      var remaining = this$1.perPage + this$1.offset - this$1.$slots.default.length;
      var shouldClone = remaining > 0;
      if (this$1.clone && shouldClone) {
        var clones = (function () {
          var cloneRecursive = function (remaining, clones) {
            if ( clones === void 0 ) clones = [];

            if (remaining > 0) {
              var newClones = clones.concat( cloneVNodes(this$1.$slots.default.slice(0, remaining), this$1.$createElement));
              return cloneRecursive(Math.max(0, remaining - newClones.length), newClones);
            } else {
              return clones;
            }
          };
          return cloneRecursive(remaining);
        })();
        return this$1.$slots.default.concat( clones.map(function (vnode, i) { return Object.assign({}, vnode, { key: ("clone" + i + (vnode.key)) }); }));
      } else {
        return this$1.$slots.default;
      }
    })();
    var children = slotWithClone.map(function (vnode) { return this$1.$parent.$createElement('div', {
      class: 'elwrapper',
      key: vnode.key,
      style: ( obj = {}, obj[this$1.orientation === 'horizontal' ? 'width' : 'height'] = ((this$1.percentage) + "%"), obj.flexShrink = '0', obj)
    }, [vnode]); });

    var measure;
    if (this.autoSize) {
      measure = h(RenderedSize, {
        on: {
          changed: function (value) {
            this$1.elementSize = value;
          }
        }
      }, [children[0]]);
    }

    var viewport = h(TransformContainer, {
      class: ['viewport', this.viewportClass],
      on: {
        tick: function (value) {
          this$1.effectiveTransform = value;
        }
      },
      props: {
        transformValue: this.transform,
        padding: this.padding,
        orientation: this.orientation
      }
    }, [h(VirtualViewport, {
      props: {
        index: this.effectiveIndex,
        perPage: this.perPage,
        orientation: this.orientation
      }
    }, children)]);

    return h('div', {
      class: {
        'slider-container': true,
        '-cannext': this.canNext,
        '-canprev': this.canPrev,
        '-is-transitioning': this.isTransitioning
      },
      style: Object.assign({
        position: 'relative'
      }, this.autoSize ? {
        height: ((this.viewportSize.height) + "px"),
        width: ((this.viewportSize.width) + "px")
      } : {
        // height: '100%',
        // width: '100%'
      })
    }, [this.$scopedSlots.prev && this.$scopedSlots.prev({ canPrev: this.canPrev, prev: this.prev, index: this.index }), measure, viewport, this.$scopedSlots.next && this.$scopedSlots.next({ canNext: this.canNext, next: this.next, index: this.index })]);
  }
};

//
var plugin = function (Vue) {

  Vue.component(Slider.name, Slider);
};

export { Slider };
export default plugin;
